import React, { Component } from 'react';
import { connect } from 'react-redux'
import { courseActions } from '../actions';

import {   Modal, ModalBody, CardHeader, CardBody, Card, Row, Col } from 'reactstrap';

import { CenterMessageCard } from 'components/CenterMessageCard';
import { LoadingPage } from 'components/LoadingPage'
import { StudentListCard } from '../components/StudentListCard';
import { SubjectListCard } from '../components/SubjectListCard';
import { TutorListCard } from '../components/TutorListCard';

import { CourseSubjectsSchedule } from '../components/CourseSubjectsSchedule';
import { CourseStudentList } from '../reports/CourseStudentList';
// Reports
import CourseEvaluationBrief from '../reports/CourseEvaluationsBrief';


import '../components/Tabs.css';
var viewActions = require ('store/view.actions');

class CourseHome extends Component {
 
        constructor(props) {
          super(props);
          
          this.state = {
            showAgenda : false ,
            showReport: false,
            selectedReport: '' 
          }
      }


      // HAY QUE CORREGIR ESTO >>
      reports = [ 
          { id: "EVAL_BRIEF", label: "Resumen de calificaciones", 
              action:  this.toggleReport.bind(this) 
            },
            { id: "STUDENT_LIST", label: "Listado de alumnos", 
            action:  this.toggleReport.bind(this) 
          }   ,
          { id: "STUDENT_LIST_FULL", label: "Nomina completa", 
          action:  this.toggleReport.bind(this) 
        }   
 
          ] ;

      toggleAgenda ( val ) {
        this.setState({ showAgenda: val }) ;
      }

      toggleReport ( val, id ) {
        this.setState({ showReport: val, selectedReport: id}) ;
      }


      componentDidMount() {
        this.props.setMainTitle('Cargando datos...', this.reports )         
        this.props.getSchoolCourse(this.props.token, this.props.match.params.id, this.props.currentCalendarID);
        this.props.getSubjects(this.props.token, this.props.match.params.id);

      }
 
      isAuth () {
        // if(this.props.user.user_type === 'TUTOR' || this.props.user.user_type === 'TEACHER') {
        //     if (this.props.course.tutors.find((tutor) => tutor.persona_id === this.props.user.persona_id)) {
        //       return true;
        //     } else {
        //       return false;
        //     }
        // } else {
          return true;
        // }
      }

     render() {
       
      return (
          <>
          <Modal toggle={() => this.toggleReport(!this.state.showReport)} isOpen={this.state.showReport}  size="xl">
            <ModalBody >
                  {this.state.selectedReport === 'EVAL_BRIEF' &&  
                    <CourseEvaluationBrief 
                      title={"Resumen de calificaciones de " + this.props.course.name}
                      qty={this.props.course.students.length}
                      courseID={this.props.course.course_id}
                      closeMe={this.toggleReport}
                    />
                  }
                   {( this.state.selectedReport === 'STUDENT_LIST' ||
                     this.state.selectedReport === 'STUDENT_LIST_FULL' ) &&  
                   <CourseStudentList
                      course={ this.props.course.name}
                      students={this.props.course.students}
                      isFull={ this.state.selectedReport === 'STUDENT_LIST_FULL'}
                   />
                  }
            </ModalBody>
          </Modal>


          {this.props.course.course_id && !this.props.view.loadingModules.getSchoolCourse ?
              <>
              {this.isAuth()?
                <div className="content">
                  
                  <Row>
                  <Col md="4">
                        <StudentListCard 
                          personas={this.props.course.students}
                          isLoading={this.props.view.isLoading}
                          enroleStudent={this.props.enroleStudent}
                          unEnroleStudent={this.props.unEnroleStudent}
                        />
                        <TutorListCard
                            topLevel={this.props.course.top_level}
                            personas={this.props.course.tutors}
                            isLoading={this.props.view.isLoading}
                            enroleTutor={this.props.enroleTutor}
                            unEnroleTutor={this.props.unEnroleTutor}
                        />

                    </Col>
                    

                    <Col md="8">
                      <Card>
                        <CardHeader>
                            <Row>
                                <Col md="4"><a href="#1" onClick={() => this.toggleAgenda(false)} >
                                    <div className={"plain-tab "+ (!this.state.showAgenda && " selected")}> Materias </div></a>
                                </Col>
                                <Col md="4"><a href="#1" onClick={() => this.toggleAgenda(true)} >
                                    <div className={"plain-tab "+ (this.state.showAgenda && " selected")}>  Horarios </div></a>
                                </Col>
                                <Col md="4"><a href={"/admin/course/"+this.props.course.course_id+"/calif"} >
                                    <div className={"plain-tab "}>  Calificaciones </div></a>
                                </Col>
                            </Row>
                        </CardHeader>
                        <CardBody>
                      {this.state.showAgenda ? 
                        < CourseSubjectsSchedule
                          subjects={this.props.courseSubjects}
                          isLoading={this.props.view.loadingModules.getSubjects}
                          minHour={6}
                                      />
                      :
                        <SubjectListCard 
                            subjects={this.props.course.courseSubjects}
                            isLoading={this.props.view.loadingModules.getSubjects}
                            toggleAgenda={this.toggleAgenda}
                            
                            scheduleClasss={this.props.scheduleClasss}
                            unScheduleClass={this.props.unScheduleClass}
                            
                            enrollTeacher={this.props.enrollTeacher}
                            unEnrollTeacher={this.props.unEnrollTeacher}
                            
                            enroleSubject={this.props.enroleSubject}
                            unEnroleSubject={this.props.unEnroleSubject}

                                    />
                      }
                        </CardBody>
                      </Card>
                    </Col>
                    


                  </Row>
                </div>
              :
              <CenterMessageCard 
                  icon="fa-info"
                  title="Autorización requerida">
                    No tenés permisos para acceder a este curso. En caso que lo requieras solicita al administrador que 
                    te agregue como tutor
                    de <b>{'Curso ' + this.props.course.name + " - Turno: " + this.props.course.shift_name }</b>
              </CenterMessageCard>  
                    }
              </>
              :
              <LoadingPage 
                title="Cargando curso"/>
              } 
           </>  
          );
    }
  }


  const mapStateToProps = state => {
    return {
        course: state.courses.course,
        courseSubjects: state.courses.courseSubjects ,
        token: state.auth.session.jwt_token,
        currentCalendarID: state.school.currentCalendarID,
        view: state.view,
        user: state.auth.session.user
    }
  }

  
  const mapDispatchToProps = dispatch => {
    return { 
        getSchoolCourse: (token, courseID, calendarID) => {
          dispatch(courseActions.getSchoolCourse(token, courseID, calendarID));
        } ,
        enroleStudent: (token, courseID, calendarID, personaID) => {
          dispatch(courseActions.enroleStudent(token, courseID, calendarID, personaID));
        },
        unEnroleStudent: (token, courseID, personaID) => {
          dispatch(courseActions.unEnroleStudent(token, courseID, personaID));
        },
        setMainTitle: ( title, menu ) => {
          dispatch(viewActions.setMainTitle(title, menu)) ;
        },
        setContextDropMenu: ( pageMenu ) => {
          dispatch(viewActions.setContextDropMenu(pageMenu)) ;
        },

        getSubjects: ( token, courseID ) => {
          dispatch(courseActions.getSubjects(token, courseID));
        },
        unScheduleClass: ( token, courseID, courseSubjectID, courseSubjectScheduleID ) => {
          dispatch( courseActions.unScheduleClass( token, courseID, courseSubjectID, courseSubjectScheduleID ));
        },
        scheduleClasss: ( token, courseID, courseSubjectID, data) => {
          dispatch( courseActions.scheduleClasss( token, courseID, courseSubjectID, data));
        },
        enrollTeacher: ( token, courseID, courseSubjectID, data) => {
          dispatch( courseActions.enrollTeacher( token, courseID, courseSubjectID, data));
        },
        unEnrollTeacher: ( token, courseID, courseSubjectID, personaID) => {
          dispatch( courseActions.unEnrollTeacher( token, courseID, courseSubjectID, personaID));
        },
        enroleSubject: ( token, courseID, courseSubjectID)  => {
          dispatch( courseActions.enrollSubject( token, courseID, courseSubjectID));
        },
        unEnroleSubject: ( token, courseID, courseSubjectID)  => {
          dispatch( courseActions.unEnroleSubject( token, courseID, courseSubjectID));
        },
        enroleTutor: (token, courseID, calendarID, personaID) => {
          dispatch(courseActions.enroleTutor(token, courseID, calendarID, personaID));
        },
        unEnroleTutor: (token, courseID, personaID) => {
          dispatch(courseActions.unEnroleTutor(token, courseID, personaID));
        }

     }
  }


  export default connect(mapStateToProps, mapDispatchToProps)(CourseHome);

